import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const CustomErrorThrower = () => {
  const globalErrorReducer = useSelector(state => state.globalErrorReducer);

  useEffect(() => {
    const { hasError, errorMessage, errorName } = globalErrorReducer;
    if (hasError) {
      const error = new Error(errorMessage);
      error.name = errorName;
      throw error;
    }
  }, [globalErrorReducer]);

  return null;
};

export default CustomErrorThrower;
